<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch5" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="7" id="pg_7" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch5" id="ch5" title="Link target outside of Sample"><b><i>Does He Hit You?</i></b></span></span></h1>
</header>
<blockquote>
<p class="VSB">Blows without hands.</p>
<p class="V">Each strike a verbal assault.</p>
<p class="V">Intimidation with a stare.</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter5.vue?2bb4e802